module.exports = __webpack_public_path__ + "static/media/schoolpic02.6fcb0482.png";